import {isLocal} from './debug';
export default function emitDatePickerEvent(eventaction, options = {}) {
    // Debug message
    if (isLocal()) {
        console.log('raise edap event - ', eventaction, options); //eslint-disable-line
    }

    // If edap does not exist, define array so overloaded push() method can raise event
    window.edap = window.edap || [];
    window.edap.push((edap) => {
        edap.trigger(eventaction, options);
    });
}
